import styled from 'styled-components';

export const TextInputWrapper = styled.div`
    position: relative;
`;
